<template>
  <md-card class="md-card-login" :class="{ 'md-card-hidden': cardHidden }">
<!--    <md-card-header :class="getClass(headerColor)">-->
<!--      <slot name="title"></slot>-->
<!--      <div class="social-line">-->
<!--        <slot name="buttons"></slot>-->
<!--      </div>-->
<!--    </md-card-header>-->

    <md-card-content>
      <img src="https://cdn.shopify.com/s/files/1/0911/4568/files/myselfie-logo-gray.png?v=1708743688">
      <slot name="description"></slot>
      
      <slot name="inputs"></slot>
      
    </md-card-content>

    <md-card-actions>
      <slot name="footer">
        
      </slot>
    </md-card-actions>
    <md-card-content>
      <slot name="spinner">

      </slot>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "login-card",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      cardHidden: true
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function() {
      this.cardHidden = false;
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>
